module.exports = __webpack_public_path__ + "static/media/articleThree.98c2c153.webp";